//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Common = require('../to/Common')
const ClassFunc = require('../../util/ClassFunc')

/**
 * The Common class acts as the base one for the common usage.
 */
const tbs_model_vo_Common = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Common.prototype = {
    genderOptions: function() {
        return [
            { label: this.localeProp('gender-option-1'), value: '1'},
            { label: this.localeProp('gender-option-2'), value: '2'}
        ]
    },
    genderDefaultValue: '1',
    sportTypeOptions: function() {
        const options = []
        for (let i = 0; i < 12; i++) {
            options.push({
                value: i.toString(),
                text: this.localeProp('sport-type-' + i),
            })
        }
        // console.log('sportTypeOptions', options)
        return options
    },
    statusOptions: function() {
        // console.log('statusOptions')
        return [
            { text: this.localeProp('status-option-1'), value: '1'},
            { text: this.localeProp('status-option-2'), value: '2'}
        ]
    }
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_Common, Common);

module.exports = tbs_model_vo_Common